import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const BrigadesPage = () => <Guide content={guides.brigades} />
